import './ContactButton.css';

function ContactButton() {
    return (
        <button className='ContactBtn' onClick={() => {}}>CONTACT ME</button>
    );
}

export default ContactButton;